import { getStorage } from "firebase/storage";
import firebaseApp from "../utils/config";

const storage = getStorage(firebaseApp);

export default storage;
